import Card from './Card';
import ScrollReveal from './Components/ScrollReveal';
import './about.css'

export default function About() {
    return (
        <div className="Page2" id="about">
            <Card animation="fade-right">
                <div className="page2-container">
                    <Card animation="fade-right">
                        <p style={{ paddingLeft: '20px' }} className="text-block">
                            Who we are
                            <br />
                            <br />
                            <ScrollReveal
                                baseOpacity={0}
                                enableBlur={true}
                                baseRotation={5}
                                blurStrength={10}
                            >
                                A student organized club at SAIT with a mission to bridge the gap between classroom and industry by providing students with
                                enriching academic, social, and professional development opportunities.
                            </ScrollReveal>
                        </p>
                        {/* <div style={{ paddingLeft: '20px', marginTop: '30px' }}>
                            <a href="/executive-team" className="meet-team-link">
                                <div className="meet-team-button">
                                    👥 Meet the Team
                                </div>
                            </a>
                        </div> */}
                    </Card>
                </div>
            </Card>
        </div>
    );
}
